import { useState } from 'react';
import { migratePayslips } from '../utils/api';
import { Loader2, CheckCircle, AlertCircle } from 'lucide-react';

const MigratePayslips = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [result, setResult] = useState(null);

    const handleSubmit = async () => {
        if (!window.confirm('Run payslip migration?')) return;

        setError('');
        setResult(null);
        setLoading(true);

        try {
            const data = await migratePayslips();
            setResult(data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleDone = () => {
        setResult(null);
        setError('');
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black flex items-center justify-center px-4">
            <div className="max-w-lg w-full">
                <div className="bg-gray-900/50 rounded-3xl shadow-lg p-8" style={{ border: '1px solid #22d3ee' }}>
                    <h2 className="text-2xl font-bold text-white mb-6 text-center">
                        Migrate Payslips
                    </h2>

                    {!result && !error && (
                        <div className="space-y-4">
                            <div className="bg-yellow-900/30 border-2 border-yellow-500 rounded-lg p-6 text-center">
                                <p className="text-yellow-300 text-sm mb-4">
                                    ⚠️ Run payslip migration
                                </p>
                                <button
                                    onClick={handleSubmit}
                                    disabled={loading}
                                    className="text-cyan-400 text-sm flex items-center justify-center mx-auto hover:underline disabled:opacity-50"
                                >
                                    {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : 'Migrate Payslips'}
                                </button>
                            </div>
                        </div>
                    )}

                    {result && (
                        <div className="space-y-4">
                            <div className="bg-green-900/30 border-2 border-green-500 rounded-lg p-6">
                                <div className="flex items-center justify-center mb-4">
                                    <CheckCircle className="w-8 h-8 text-green-400" />
                                </div>
                                <p className="text-green-300 text-sm text-center mb-4 font-semibold">
                                    Successful Migration
                                </p>
                                <div className="text-gray-300 text-sm space-y-1">
                                    <p><strong>Total records:</strong> {result.total}</p>
                                    <p><strong>Updated:</strong> {result.updated}</p>
                                    <p><strong>Already had:</strong> {result.already_has}</p>
                                    <p><strong>No match:</strong> {result.no_match}</p>
                                    <p><strong>Errors:</strong> {result.errors}</p>
                                </div>
                            </div>
                            <button
                                onClick={handleDone}
                                className="w-full py-2 px-4 rounded-full bg-gradient-to-br from-gray-800 via-gray-700 to-black text-white font-medium"
                                style={{ border: '1px solid #22d3ee' }}
                            >
                                Proceed
                            </button>
                        </div>
                    )}

                    {error && (
                        <div className="space-y-4">
                            <div className="bg-red-900/30 border-2 border-red-500 rounded-lg p-6">
                                <div className="flex items-center justify-center mb-4">
                                    <AlertCircle className="w-8 h-8 text-red-400" />
                                </div>
                                <p className="text-red-300 text-sm text-center">
                                    {error}
                                </p>
                            </div>
                            <button
                                onClick={handleDone}
                                className="w-full py-2 px-4 rounded-full bg-gradient-to-br from-gray-800 via-gray-700 to-black text-white font-medium"
                                style={{ border: '1px solid #22d3ee' }}
                            >
                                Try Again
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MigratePayslips;